import { screeningsRoutes } from '@/backend/routes';
import { AppContext } from '@/ui/Context';
import { CredentialingProvider } from '@/ui/providers';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { usePermission } from '@juvare/contact-management/ui/hooks';
import { CredentialVerificationDetailsPage } from '@juvare/credentialing/ui/features/credentialing-verification/components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes, useNavigate } from 'react-router';
import { BackgroundCheckUserPanel } from '../background-check';
import { ScreeningsPage } from './components/ScreeningsPage';

export const ScreeningsRouter: React.FC = () => {
    const { t } = useTranslation();
    const appContext = React.useContext(AppContext);
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const { requireAnySystemPermission } = usePermission();
    const navigateBackTitle = t('pages.screenings.backToRootScreening');
    const handleNavigateBack = () => navigationContext.navigate(() => navigate(`/${screeningsRoutes.root}`));

    const canViewBackgroundCheckHistory = requireAnySystemPermission(
        'view-partial-background-check-history',
        'view-full-background-check-history',
    );

    return (
        <CredentialingProvider>
            <Routes>
                <Route path='*' element={<ScreeningsPage showBackgroundCheckSummary={canViewBackgroundCheckHistory} />} />
                <Route
                    path='/credentials/*'
                    element={
                        <CredentialVerificationDetailsPage
                            navigateBackTitle={navigateBackTitle}
                            onNavigateBack={handleNavigateBack}
                            userDisplayName={appContext.userState?.displayName}
                            reviewProfileTabName='occupations'
                        />
                    }
                />
                {canViewBackgroundCheckHistory && (
                    <Route
                        path='/background-checks/*'
                        element={<BackgroundCheckUserPanel navigateBackTitle={navigateBackTitle} onNavigateBack={handleNavigateBack} />}
                    />
                )}
            </Routes>
        </CredentialingProvider>
    );
};
